import { render, staticRenderFns } from "./NewGameRecommend.vue?vue&type=template&id=229c628a"
import script from "./NewGameRecommend.vue?vue&type=script&lang=js"
export * from "./NewGameRecommend.vue?vue&type=script&lang=js"
import style0 from "./NewGameRecommend.vue?vue&type=style&index=0&id=229c628a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports